import scrollInView from './scrollIntoView'
export default {
    data() {
        return { hoverIndex: -1 }
    },

    methods: {
        getHoveredLi() {
            let popperElm = this.$refs.dropdown.popperElm;
            let hoverLi = popperElm.querySelector('ul li.hover');

            return hoverLi;
        },

        navigateOptions(direction) {
            if(!this.itemsLength) {
                return;
            }
            if(direction === 'next') {
                this.hoverIndex++;
                if(this.hoverIndex === this.itemsLength) {
                    this.hoverIndex = 0;
                }
            }
            else {
                this.hoverIndex--;
                if(this.hoverIndex < 0) {
                    this.hoverIndex = this.itemsLength - 1;
                }
            }
            
            this.$nextTick(() => {
                let hoverLi = this.getHoveredLi();
                scrollInView(this.$refs.dropdown.popperElm, hoverLi)
            });
        },

        selectHoveredOption() {
            let hoverLi = this.getHoveredLi();
            hoverLi && hoverLi.click();
        }
    }
}



            


// WEBPACK FOOTER //
// ./src/util/keyupdown.js